<template>
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-form">
      <!--begin::Form-->
      <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="kt-font-brand flaticon-home"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="kt-section kt-section--first">
            <div class="row">
              <!-- begin: ประเภทกิจกรรม -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">ประเภทกิจกรรม:</label>
                  <span class="form-control-plaintext">{{
                    mktaObjectives
                  }}</span>
                </div>
              </div>
              <!-- end: ประเภทกิจกรรม -->
              <!-- begin: ชื่อกิจกรรม -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">ชื่อกิจกรรม:</label>
                  <span class="form-control-plaintext">{{
                    mktaActivityName
                  }}</span>
                </div>
              </div>
              <!-- end: ชื่อกิจกรรม -->
              <!-- begin: ตัวเทนจำหน่าย -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">ตัวเทนจำหน่าย:</label>
                  <span class="form-control-plaintext">{{
                    mktaAgentName
                  }}</span>
                </div>
              </div>
              <!-- end: ตัวเทนจำหน่าย -->
              <!-- begin: ชื่อร้านค้า -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">ชื่อร้านค้า:</label>
                  <span class="form-control-plaintext">{{ mktaShopName }}</span>
                </div>
              </div>
              <!-- end: ชื่อร้านค้า -->
              <!-- begin: ชื่อร้านค้า 2 -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">ชื่อร้านค้า 2:</label>
                  <span class="form-control-plaintext">{{
                    mktaShopName2
                  }}</span>
                </div>
              </div>
              <!-- end: ชื่อร้านค้า 2 -->
              <!-- begin: จังหวัด -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">จังหวัด:</label>
                  <span class="form-control-plaintext">{{
                    mktaProvinceName
                  }}</span>
                </div>
              </div>
              <!-- end: จังหวัด -->
              <!-- begin: ประเภทร้านค้า -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">ประเภทร้านค้า:</label>
                  <span class="form-control-plaintext">{{ mktaShopType }}</span>
                </div>
              </div>
              <!-- end: ประเภทร้านค้า -->
              <!-- begin: วันที่ -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">วันที่:</label>
                  <span class="form-control-plaintext">{{
                    mktaActivityDate
                  }}</span>
                </div>
              </div>
              <!-- end: วันที่ -->
              <!-- begin: วันที่เริ่มต้น -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">วันที่เริ่มต้น:</label>
                  <span class="form-control-plaintext">{{
                    mktaActivityDateStart
                  }}</span>
                </div>
              </div>
              <!-- end: วันที่เริ่มต้น -->
              <!-- begin: วันที่สิ้นสุด -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">วันที่สิ้นสุด:</label>
                  <span class="form-control-plaintext">{{
                    mktaActivityDateEnd
                  }}</span>
                </div>
              </div>
              <!-- end: วันที่สิ้นสุด -->
              <!-- begin: พื้นที่กิจกรรม -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">พื้นที่กิจกรรม: </label>
                  <GmapMap
                    :center="{ lat: mktaNLat, lng: mktaNLng }"
                    :zoom="15"
                    :clickable="true"
                    style="width: 500px; height: 300px"
                  >
                    <gmap-marker
                      :key="index"
                      v-for="(m, index) in mktaMarkers"
                      :position="m.positionN"
                      :draggable="false"
                      :clickable="true"
                      icon="http://maps.google.com/mapfiles/ms/icons/red-dot.png"
                      title="พื้นที่ใหม่"
                    >
                    </gmap-marker>
                    <gmap-marker
                      :key="index"
                      v-for="(m, index) in mktaMarkers"
                      :position="m.positionO"
                      :draggable="false"
                      :clickable="true"
                      icon="http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
                      title="พื้นที่เดิม"
                    >
                    </gmap-marker>
                  </GmapMap>
                  <label class="label"
                    ><span style="color:red">สีแดง:พื้นที่ใหม่</span> ,
                    <span style="color:#DAA520"
                      >สีเหลือง:พื้นที่เดิม</span
                    ></label
                  >
                </div>
              </div>
              <!-- end: พื้นที่กิจกรรม -->
            </div>
          </div>
        </div>
        <div class="kt-portlet__foot">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="$router.go(-1)"
          >
            <i class="la la-close"></i> ย้อนกลับ
          </button>
          <button
            type="button"
            class="btn btn-success"
            @click="onApprove($event)"
            v-if="mktaIsApprove === true"
          >
            <i class="la la-check"></i> อนุมัติ
          </button>
          <button
            type="button"
            class="btn btn-danger"
            @click="onReject($event)"
            v-if="mktaIsApprove === true"
          >
            <i class="la la-close"></i> ไม่อนุมัติ
          </button>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCeGao-PkONmiyVksl46W_OUHt854bcrqE",
    libraries: "places",

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
});

export default {
  components: {},
  data: function() {
    var self = this;

    return {
      mktaObjectives: null,
      mktaActivityName: null,
      mktaAgentName: null,
      mktaShopName: null,
      mktaShopName2: null,
      mktaProvinceName: null,
      mktaActivityDate: null,
      mktaActivityDateStart: null,
      mktaActivityDateEnd: null,
      mktaShopType: null,
      mktaSaleItemPG: [],
      mktaSaleItem: [],
      mktaBuget: null,
      mktaItem: [],
      mktaNLat: null,
      mktaNLng: null,
      mktaOLat: null,
      mktaOLng: null,
      mktaMarkers: [],
      mktaIsApprove: false,
    };
  },

  methods: {
    onApprove: function(e) {
      e.preventDefault();
      let self = this;
      let router = this.$router;
      Swal.fire({
        title: "คำสั่งอนุมัติแก้ไขข้อมูลพื้นที่กิจกรรม",
        type: "warning",
        html: "กรุณายืนยันอนุมัติแก้ไขข้อมูลพื้นที่กิจกรรม <strong>",
        inputValue: 0,
        inputPlaceholder: "อนุมัติแก้ไขข้อมูลพื้นที่กิจกรรม",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังอนุมัติข้อมูล กรุณารอสักครู่...",
          });

          //UpdateBorrowProduct
          if (self.ubpIsEdit) {
            self.formSubmit();
          }

          axios
            .get("/Api/Marketing/" + this.$route.params.id + "/Approve")
            .then(function(response) {
              if (response.data.status) {
                Swal.fire("สำเร็จ", response.data.message, "success").then(
                  function() {
                    router.go(-1), self.$parent.reloadDataTable(false);
                    //router.push({ path: `/Borrow` });
                  }
                );
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
    onReject: function(e) {
      e.preventDefault();
      let self = this;
      let router = this.$router;
      Swal.fire({
        title: "คำสั่งไม่อนุมัติแก้ไขข้อมูลพื้นที่กิจกรรม",
        type: "warning",
        html: "กรุณายืนยันไม่อนุมัติแก้ไขข้อมูลพื้นที่กิจกรรม <strong>",
        // input: "text",
        // inputAttributes: {
        //   autocapitalize: "off",
        // },
        // // inputValue: 0,
        // inputPlaceholder:
        //   "กรุณาระบุหมายเหตุผลไม่อนุมัติแก้ไขข้อมูลพื้นที่กิจกรรม",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        // inputValidator: (value) => {
        //   return new Promise((resolve) => {
        //     if (value === "") {
        //       resolve("กรุณาระบุเหตุผลไม่อนุมัติแก้ไขข้อมูลพื้นที่กิจกรรม");
        //     } else {
        //       resolve();
        //     }
        //   });
        // },
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
          });
          axios({
            method: "post",
            url: "/Api/Marketing/Reject",
            data: {
              Id: this.$route.params.id,
              Remark: result.value,
            },
          })
            // .post("/Api/ProductLoan/" + this.$route.params.id + "/Reject",)
            .then(function(response) {
              if (response.data.status) {
                Swal.fire("สำเร็จ", response.data.message, "success").then(
                  function() {
                    router.go(-1), self.$parent.reloadDataTable(false);
                    //router.push({ path: `/Borrow` });
                  }
                );
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        } else {
        }
      });
    },
  },
  computed: {},
  async mounted() {
    let self = this;
    let router = this.$router;

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
    });

    axios
      .get("/Api/Marketing/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          if (response.data != null) {
            (self.mktaObjectives = response.data.objectives),
              (self.mktaActivityName =
                response.data.activityName != null
                  ? response.data.activityName
                  : "-"),
              (self.mktaAgentName = response.data.agentName),
              (self.mktaShopName =
                response.data.shopName != null ? response.data.shopName : "-"),
              (self.mktaShopName2 =
                response.data.shopName2 != null && response.data.shopName2 != ""
                  ? response.data.shopName2
                  : "-"),
              (self.mktaProvinceName = response.data.provinceName),
              (self.mktaActivityDate =
                response.data.activityDateString != null
                  ? response.data.activityDateString
                  : "-"),
              (self.mktaActivityDateStart =
                response.data.activityDateStartString != null
                  ? response.data.activityDateStartString
                  : "-"),
              (self.mktaActivityDateEnd =
                response.data.activityDateEndString != null
                  ? response.data.activityDateEndString
                  : "-"),
              (self.mktaShopType =
                response.data.shopType != null ? response.data.shopType : "-"),
              (self.mktaSaleItemPG = response.data.saleItems.filter(
                (o) => o.saleItemTypeCode == "MKT_SALE_ITEM_TYPE_PG"
              )),
              (self.mktaSaleItem = response.data.saleItems.filter(
                (o) => o.saleItemTypeCode == "MKT_SALE_ITEM_TYPE_SALE"
              )),
              (self.mktaBuget = new Intl.NumberFormat().format(
                response.data.budget
              )),
              (self.mktaItem = response.data.items),
              (self.mktaIsApprove = response.data.isRequestChange),
              (self.mktaNLat = parseFloat(response.data.newLatitude)),
              (self.mktaNLng = parseFloat(response.data.newLongitude)),
              (self.mktaOLat = parseFloat(response.data.oldLatitude)),
              (self.mktaOLng = parseFloat(response.data.oldLongitude)),
              (self.mktaMarkers = [
                {
                  positionN: { lat: self.mktaNLat, lng: self.mktaNLng },
                  positionO: { lat: self.mktaOLat, lng: self.mktaOLng },
                },
              ]);
          }
          console.log(self.mktaNLat);
          console.log(self.mktaNLng);
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่พบข้อมูลการสั่งซื้อที่คุณเลือก",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลการสั่งซื้อได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed

        KTApp.unblockPage();
      });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Marketing/MarketingApproveDetail.vue